import { TFunction } from 'i18next'
import { SurveyQuestionType } from '@/features/forms-and-surveys/types'

export const QUESTION_TYPES: SurveyQuestionType[] = [
  'Text',
  'SingleChoice',
  'MultipleChoice',
  'Rating',
  'YesNo',
  'CTA',
]

// This function will be used to get translated labels
export function getQuestionTypeLabels(
  t: TFunction
): Record<SurveyQuestionType, string> {
  return {
    Text: t('surveys.questionTypeText'),
    SingleChoice: t('surveys.questionTypeSingleChoice'),
    MultipleChoice: t('surveys.questionTypeMultipleChoice'),
    Rating: t('surveys.questionTypeRating'),
    YesNo: t('surveys.questionTypeYesNo'),
    CTA: t('surveys.questionTypeCTA'),
  }
}
